import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetMembershipApi } from 'src/Services/API';
import { MemberDeletionCheckDto } from 'src/Services/API/generated';
import { ApiError } from 'src/types/api-error.types';

export const useFetchMemberDeletionCheck = (membershipId: string | null) => {
  const assetId = useCurrentAssetId();

  return useQuery<MemberDeletionCheckDto, AxiosError<ApiError>>({
    queryKey: ['fetch-member-deletion-check', assetId, membershipId],
    queryFn: async () => {
      if (!assetId || !membershipId) throw new Error('assetId and membershipId are required');
      return (await assetMembershipApi.membersControllerGetDeletionCheck(membershipId, assetId))
        .data;
    },
    enabled: !!assetId && !!membershipId,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};
